import React from "react";
import { FormControl, FormErrorMessage, FormLabel } from "@chakra-ui/react";
import { Box, Button, Flex, Input, Select, Spinner } from "@familyzone/component-library";
import { useSessionStore } from "../storez/SessionStore";
import isValidHostnameOrIP from "../utils/isValidHostnameOrIp";
import SectionHeading from "./header/components/SectionHeading";
import Api from "../utils/Api";
import { withToast } from "../utils/ReactUtil";

class DiagsCollectToolComponent extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      running: false,
      coolDown: false,
      result: null,
    };
  }

  collect = (event) => {
    let self = this;

    if (event) {
      event.preventDefault();
    }

    self.setState({
      running: true,
      coolDown: true,
    });

    Api.post(
      "/ajax/diags/collect",
      {},
      () => {
        self.setState({
          running: false,
          result: "Collected diagnostics will appear under Logfiles shortly.",
        });
        setTimeout(() => {
          self.setState({ coolDown: false });
        }, 60000);
      },
      () => {
        self.setState({
          running: false,
          coolDown: false,
          result: "Diagnostics collection failed. Linewize appliance is currently unavailable.",
        });
        this.props.errorToast({
          title: "Diagnostics Collection Failed",
          description: "Linewize appliance is currently unavailable.",
          isClosable: true,
        });
      }
    );
  };

  render = () => {
    return (
      <Box>
        <SectionHeading title="Diagnostics Collection Tool" />
        <Box px="sp12" py="sp16">
          <FormControl mb="sp16" isDisabled={this.state.coolDown}>
            <Button variant="primary" isDisabled={this.state.coolDown} onClick={this.collect}>
              Collect
            </Button>
          </FormControl>
          <Box>{this.state.result}</Box>
          {this.state.running && (
            <Box mt="sp8">
              <Spinner size="md" />
            </Box>
          )}
        </Box>
      </Box>
    );
  };
}

export const DiagsCollectTool = withToast(DiagsCollectToolComponent);

class PingToolComponent extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      hostname: "",
      ping_count: 0,
      running: false,
      last_results: [],
    };
  }

  startPing = () => {
    let self = this;
    Api.get(
      "/ajax/ping/" + this.state.hostname,
      function (result) {
        /* Update the resultset */
        self.state.last_results.push(result["online"]);
        self.setState({
          ping_count: (self.state.ping_count += 1),
          last_results: self.state.last_results,
        });

        if (self.state.ping_count < 6) {
          self.startPing();
        } else {
          self.setState({
            running: false,
          });
        }
      },
      () => {
        self.setState({ running: false });

        this.props.errorToast({
          title: "Ping Request Failed",
          description: "Linewize appliance is currently unavailable.",
          isClosable: true,
        });
      }
    );
  };

  handlePing = (event) => {
    event.preventDefault();
    this.setState({
      ping_count: 0,
      running: true,
      last_results: [],
    });

    this.startPing();
  };

  renderResults = () => {
    let ret = [];
    for (let result of this.state.last_results) {
      if (result > 0) {
        ret.push(
          <div>
            64 bytes from {this.state.hostname}: time={result} ms
          </div>
        );
      } else {
        ret.push(<div>Failed to ping {this.state.hostname}</div>);
      }
    }

    return ret;
  };

  handle_ChangeHostname = (event) => {
    this.setState({
      hostname: event.target.value,
      last_results: [],
      running: false,
    });
  };

  render() {
    return (
      <Box>
        <SectionHeading title="Ping Tool" />
        <Box px="sp12" py="sp16">
          <FormControl mb="sp16" isDisabled={this.state.running}>
            <FormLabel>Hostname or IP Address</FormLabel>
            <Flex gap="sp8">
              <Input
                type="text"
                name="hostname"
                value={this.state.hostname}
                isDisabled={this.state.running}
                onChange={this.handle_ChangeHostname}
              />
              <Button variant="primary" isDisabled={this.state.running} onClick={this.handlePing}>
                Ping
              </Button>
            </Flex>
          </FormControl>
          <Box>{this.renderResults()}</Box>
          {this.state.running && (
            <Box mt="sp8">
              <Spinner size="md" />
            </Box>
          )}
        </Box>
      </Box>
    );
  }
}

export const PingTool = withToast(PingToolComponent);

class TracerouteToolComponent extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      hostname: "",
      result: [],
      loading: false,
    };
  }

  renderResults = () => {
    let ret = [];
    for (let result of this.state.result) {
      ret.push(<div>{result}</div>);
    }

    return ret;
  };

  handleTraceroute = (event) => {
    event.preventDefault();
    /* reset the results */
    this.setState({
      result: [],
      traceRouteError: "",
      running: true,
    });

    if (!isValidHostnameOrIP(this.state.hostname)) {
      this.setState({
        traceRouteError: "Please ensure that the format is an IPv4 address or a hostname",
        running: false,
      });
      return;
    }

    let self = this;
    Api.get(
      "/ajax/traceroute/" + this.state.hostname,
      function (result) {
        self.setState({
          result: result["result"],
          running: false,
        });
      },
      () => {
        self.setState({ running: false });

        this.props.errorToast({
          title: "Traceroute Request Failed",
          description: "Linewize appliance is currently unavailable.",
          isClosable: true,
        });
      }
    );
  };

  handle_ChangeHostname = (event) => {
    this.setState({
      hostname: event.target.value,
      result: [],
      running: false,
    });
  };

  render() {
    return (
      <Box>
        <SectionHeading title="Traceroute Tool" />
        <Box px="sp12" py="sp16">
          <FormControl mb="sp16" isDisabled={this.state.running} isInvalid={!!this.state.traceRouteError}>
            <FormLabel>Hostname or IP Address</FormLabel>
            <Flex gap="sp8">
              <Input
                type="text"
                name="hostname"
                value={this.state.hostname}
                isDisabled={this.state.running}
                onChange={this.handle_ChangeHostname}
              />
              <Button variant="primary" isDisabled={this.state.running} onClick={this.handleTraceroute}>
                Trace
              </Button>
            </Flex>
            {this.state.traceRouteError && (
              <FormErrorMessage fontWeight="regular" mt="sp8">
                {this.state.traceRouteError}
              </FormErrorMessage>
            )}
          </FormControl>
          <Box>{this.renderResults()}</Box>
          {this.state.running && (
            <Box mt="sp8">
              <Spinner size="md" />
            </Box>
          )}
        </Box>
      </Box>
    );
  }
}

export const TracerouteTool = withToast(TracerouteToolComponent);

const packetCaptureStatus = {
  INACTIVE: "inactive",
  CAPTURING: "capturing",
  STOPPING: "stopping",
  DOWNLOADING: "downloading",
};

class CaptureToolComponent extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      filter: "",
      interface: "",
      devices: [],
      interfacesLoaded: false,

      status: packetCaptureStatus.INACTIVE,
      status__no_packets: 0,
      interval: undefined,
    };
  }

  componentDidMount() {
    let self = this;

    this.fetchInterfaces();
    this.setState({
      interval: setInterval(function () {
        self.handleLoad();
      }, 2000),
    });
  }

  componentWillUnmount() {
    if (this.state.interval) {
      clearInterval(this.state.interval);
    }
  }

  fetchInterfaces = () => {
    Api.get(
      "/config/device/ajax/network/devices",
      (result) => {
        this.setState({ devices: result["data"], interfacesLoaded: true });
      },
      () => {
        this.setState({ devices: [], interfacesLoaded: true });
      }
    );
  };

  handleLoad = () => {
    if (this.state.status !== packetCaptureStatus.CAPTURING && this.state.status !== packetCaptureStatus.STOPPING) return;

    Api.get("/ajax/capture", (result) => {
      this.setState({
        status__no_packets: result.result.no_packets_captured,
      });

      if (result.result.running) return;

      if (this.state.status === packetCaptureStatus.CAPTURING) {
        Api.post("/ajax/capture/stop", {}, (result) => {});
      }

      if (this.state.status === packetCaptureStatus.DOWNLOADING || this.state.status === packetCaptureStatus.INACTIVE) return;

      this.setState({
        status: packetCaptureStatus.DOWNLOADING,
      });

      this.downloadCapture("/ajax/capture/download", this.state.interface);
    });
  };

  downloadCapture = (url, capture_interface) => {
    const session = useSessionStore.getState();

    let req = new XMLHttpRequest();
    req.open("GET", url + "?t=" + Date.now(), true);
    req.setRequestHeader("Content-type", "application/zip");
    req.setRequestHeader("Device", session.getDevice().id);
    req.setRequestHeader("Token", session.getToken());
    req.responseType = "blob";
    req.onload = (event) => {
      if (event.currentTarget.status === 200) {
        let blob = req.response;
        let link = document.createElement("a");
        link.style = "display: none";
        let url = window.URL.createObjectURL(blob);
        link.href = url;
        link.download = "capture_".concat(capture_interface, ".pcap");
        document.body.appendChild(link);
        link.click();
        setTimeout(function () {
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }, 100);
      }

      this.setState({
        status: packetCaptureStatus.INACTIVE,
      });
    };
    req.send();
  };

  handleButton = (event) => {
    event.preventDefault();

    if (this.state.status === packetCaptureStatus.CAPTURING) {
      this.setState({
        status: packetCaptureStatus.STOPPING,
      });

      Api.post(
        "/ajax/capture/stop",
        {},
        (result) => {},
        () => {
          this.props.errorToast({
            title: "Please Try Again",
            description: "Failed to stop network capture.",
            isClosable: true,
          });
        }
      );
    } else {
      Api.post(
        "/ajax/capture/start",
        {
          interface: this.state.interface,
          target: this.state.filter,
        },
        (result) => {
          this.setState({
            status: packetCaptureStatus.CAPTURING,
            status__no_packets: 0,
          });
          this.handleLoad();
        },
        () => {
          this.props.errorToast({
            title: "Please Try Again",
            description: "Failed to start network capture.",
            isClosable: true,
          });
        }
      );
    }
  };

  handle_ChangeFilter = (event) => {
    this.setState({
      filter: event.target.value,
    });
  };

  handle_ChangeInterface = (event) => {
    this.setState({
      interface: event.value,
    });
  };

  get_SelectionMap = () => {
    let ret = [];
    for (let x of this.state.devices) {
      ret.push({ value: x.interface });
    }

    return ret;
  };

  renderResults = () => {
    if (!this.state.interfacesLoaded) {
      return <Box>Loading network interfaces...</Box>;
    }

    switch (this.state.status) {
      case packetCaptureStatus.CAPTURING:
        return <Box data-testid="result-message">Capture running, collected {this.state.status__no_packets} packets</Box>;
      case packetCaptureStatus.DOWNLOADING:
        return <Box data-testid="result-message">Downloading capture...</Box>;
      default:
        return <Box data-testid="result-message"></Box>;
    }
  };

  renderButton = ({ disabled }) => {
    switch (this.state.status) {
      case packetCaptureStatus.CAPTURING:
        return (
          <Button variant="danger" onClick={this.handleButton}>
            Stop
          </Button>
        );

      case packetCaptureStatus.STOPPING:
      case packetCaptureStatus.DOWNLOADING:
        return <Box />;

      default:
        return (
          <Button variant="primary" isDisabled={disabled} onClick={this.handleButton}>
            Start
          </Button>
        );
    }
  };

  render() {
    const loading = !this.state.interfacesLoaded;
    const running = this.state.status !== packetCaptureStatus.INACTIVE;
    const unavailable = this.state.devices?.length === 0;
    const disabled = loading || running || unavailable;
    return (
      <Box>
        <SectionHeading title="Capture Tool" />
        <Box px="sp12" py="sp16" minHeight="240px">
          <FormControl mb="sp16" isDisabled={disabled}>
            <FormLabel>Filter</FormLabel>
            <Input type="text" name="filter" value={this.state.filter} isDisabled={disabled} onChange={this.handle_ChangeFilter} />
          </FormControl>
          <FormControl mb="sp16" isDisabled={disabled} isInvalid={unavailable}>
            <FormLabel id="captureTool.interface-label" htmlFor="captureTool.interface-input">
              Interface
            </FormLabel>
            <Flex gap="sp8">
              <Select
                id="captureTool.interface"
                items={this.get_SelectionMap()}
                disabled={disabled}
                onChange={this.handle_ChangeInterface}
              />
              {this.renderButton({ disabled })}
            </Flex>
            {!loading && unavailable && (
              <FormErrorMessage fontWeight="regular" mt="sp8">
                Capture unavailable due to network interfaces not found.
              </FormErrorMessage>
            )}
          </FormControl>
          <Box>{this.renderResults()}</Box>
          {(loading || running) && (
            <Box mt="sp8">
              <Spinner size="md" />
            </Box>
          )}
        </Box>
      </Box>
    );
  }
}

export const CaptureTool = withToast(CaptureToolComponent);
